import "./App.css";
import AppRouter from "./AppRouter";
import { ToastContainer } from "react-toastify";

import React, { useEffect } from "react";
import { startWebSocket } from "./common/Socket";
import { getFromEncLocalStorage } from "./helpers/Utils/Utils";
import CommonService from "./services/CommonService";
import GcpFileUploadComponent from "./Pages/Masters/GoogleStorage/GcpFileUploadComponent";
//import { hot } from "react-hot-loader/root";
//force build

export function getUrl() {
  fetch("./appconfig.json")
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      let url = JSON.stringify(data.base_url);

      return url;
    })
    .catch(function (err) {
      console.log(err, " error");
    });
}

// force build_20251216_145913

function App() {
  // useEffect(() => {
  //   let url = getUrl();
  //   console.log(url);
  // }, []);

  useEffect(() => {
    // startWebSocket();
    // // OneSignal.push(() => {
    // //   OneSignal.init({
    // //     appId: "1cb54eed-e756-4fef-97d5-1b1f3855cdf5",
    // //   });
    // // });
  }, []);

  // window.OneSignal = window.OneSignal || [];
  // const OneSignal = window.OneSignal;

  // // OneSignal.OSNotificationReceivedEvent((data) => console.log(data));
  // // OneSignal.on([
  // //   "addListenerForNotificationOpened",
  // //   function (data) {
  // //     console.log("Received NotificationOpened:");
  // //     console.log(data);
  // //   },
  // // ]);

  // // replace console.* for disable log on production
  // if (process.env.NODE_ENV === "production") {
  //   console.log = () => { };
  //   console.error = () => { };
  //   console.debug = () => { };
  // }

  const token = getFromEncLocalStorage("token");

  useEffect(() => {
    if (token != null && token != undefined && token != "") {
      const executeTask = async () => {
        await CommonService.saveSASToken();
      };

      // Execute the task immediately upon first render
      executeTask();

      const intervalId = setInterval(async () => {
        await CommonService.saveSASToken();
      }, 90 * 1000); // Run every 1.5 minutes

      return () => clearInterval(intervalId);
    }
  }, [token]);

  return (
    <div>
      <ToastContainer />
      {/* {localStorage.getItem("GcpFileUploadComponent") ==
      "GcpFileUploadComponent" ? (
        <GcpFileUploadComponent />
      ) : ( */}
      <AppRouter />
      {/* )} */}
    </div>
  );
}

export default App;
